var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWoo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.604 18.339-2.315-5.546a3.558 3.558 0 0 0-3.327-2.32c-1.465 0-2.769.908-3.31 2.29l-2.39 5.575-3.662-12.34H2l5.465 18.062a1.59 1.59 0 0 0 1.524 1.145h2.636c.66 0 1.246-.402 1.48-1.026l2.828-7.09 2.887 7.106c.25.61.836 1.01 1.48 1.01h2.609c.702 0 1.317-.46 1.522-1.13l2.623-8.562h-4.6l-.85 2.825zm3.722-12.34H30l-2.212 7.15h-4.616L25.326 6z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoo);
export default __webpack_public_path__ + "static/media/WOO.f45d37811d49b5deaf0fbb1cd1c448f1.svg";
export { ForwardRef as ReactComponent };